// extracted by mini-css-extract-plugin
export default {"iconSettingBusinessType":"routeBuilder-scoped__iconSettingBusinessType--wXYqf"};